import React from 'react';
export const DevToolsWidget = function EmptyComponent() { return null; };
